import React, { useCallback, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Row,
  Col,
  Input,
  FormGroup,
  Label,
  InputGroup,
  Button,
} from "reactstrap";
import Title from "../title";
import { Field } from "formik";
import { useDropzone } from "react-dropzone";
import Resizer from "react-image-file-resizer";
import { api } from "../../api/api";
import "react-phone-number-input/style.css";
import moment from "moment";
import DatePicker from "react-datepicker";
import { pickerDate } from "../voiceAdd/openForm";
import "react-datepicker/dist/react-datepicker.css";
import { store } from "../../redux/storeConfig/store";
import {
  getCourts,
  getPackages,
  getPayRates,
  getPayRatesType,
  getTrainer,
} from "../../redux/actions/api/apiAction";
import { TextWithSelect } from "../textWithSelect";
import {
  cancelationOptions,
  endOptions,
  getBookingsWindowsDates,
  startOptions,
} from "./utils";
import ReactSelect from "react-select";
import { customStyle } from "../court/utils";
import { FormatObjects } from "../court/bookCourt/utils";

const weekDays = [
  {
    value: "sat",
    label: "Saturday",
  },
  {
    value: "sun",
    label: "Sunday",
  },
  {
    value: "mon",
    label: "Monday",
  },
  {
    value: "tue",
    label: "Tuesday",
  },
  {
    value: "wed",
    label: "Wednesday",
  },
  {
    value: "thu",
    label: "Thursday",
  },
  {
    value: "fri",
    label: "Friday",
  },
];

const DropZone = ({ values, setFieldValue, errors, icon }) => {
  const maxSize = 10485760;
  const onDrop = useCallback((acceptedFiles) => {
    let file = acceptedFiles[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = async (event) => {
        Resizer.imageFileResizer(
          file,
          300,
          300,
          "PNG",
          100,
          0,
          async (uri) => {
            let data = {
              fileName: acceptedFiles[0].name,
              source: uri,
              folder: "profile",
            };
            var url = await api(`file`, data, "post");
            if (url.data.status === 201) {
              setFieldValue("image", url.data.data);
            }
          },
          "base64",
          300,
          300
        );
      };
      reader.readAsDataURL(file);
    }
  }, []);
  const {
    isDragActive,
    getRootProps,
    getInputProps,
    isDragReject,
    acceptedFiles,
    rejectedFiles,
  } = useDropzone({
    onDrop,
    minSize: 0,
    maxSize: 10485760,
    accept: "image/*",
  });
  return (
    <div className="upload-profilephoto">
      <div className="file-input" {...getRootProps()}>
        <h6 className="upload-link mb-0"> {icon}Upload Image </h6>
        <input {...getInputProps()} />
      </div>
    </div>
  );
};

export const WorkshopForm = (formikProps) => {
  const { errors, touched, values, setFieldValue } = formikProps;
  const trainerList = useSelector((state) => state.trainer.allTrainers);
  const login = useSelector((state) => state.login);
  const { gym } = useSelector((state) => state.gym);
  const perm = useSelector((state) => state.permissions);
  const [toDelete, setToDelete] = React.useState(null);
  const [relation, setRelation] = React.useState([]);
  const [changed, setChanged] = React.useState(false);
  const voicePrefill = useSelector((state) => state.voiceAdd && state.voiceAdd.prefill);
  const voiceWorkshopApplied = React.useRef(false);
  React.useEffect(() => {
    if (voiceWorkshopApplied.current) return;
    if (!voicePrefill || voicePrefill.type !== "workshop") return;
    const trainer = voicePrefill.fields && voicePrefill.fields.trainer;
    if (trainer && trainer.id) setFieldValue("trainer", String(trainer.id));
    voiceWorkshopApplied.current = true;
  }, [voicePrefill]);
  const [showAllowUnpaidBookings, setShowAllowUnpaidBookings] = React.useState(
    true
  );
  const payRatesType = useSelector((state) => state.payRoll.payRatesType);
  const payRates = useSelector((state) => state.payRoll.payRates);
  const { slotsForBookingWindow, courts } = useSelector((state) => state.court);
  const [timesCounter, setTimesCounter] = React.useState([0]);
  const [timeRanges, seTimeRanges] = React.useState([]);
  const [datesTouched, setDatesTouched] = React.useState(false);
  const { permissions, subAdminType, subAdminPermissions } = perm;
  const { loginUser } = login;
  const [restrictGender, setRestrictGender] = React.useState(false);
  const [payRatesSelected, setPayRatesSelected] = useState([]);
  const [payRatesRender, setPayRatesRender] = useState([]);
  const [selectedPayRateType, setSelectedPayRateType] = useState("");
  const [selectedPayRate, setSelectedPayRate] = useState("");
  const [isPayRatesSelected, setIsPayRatesSelected] = useState(false);
  const { gymFeaturesObject } = useSelector((state) => state.features);

  const dispatch = useDispatch();

  const getArrayOfDatesInRange = () => {
    const { startDate, endDate } = values;
    const momentedStartDate = moment(startDate);
    const momentedendDate = moment(endDate);
    let result = [moment({ ...momentedStartDate })];

    while (
      momentedStartDate.format("YYYY-MM-DD") !=
      momentedendDate.format("YYYY-MM-DD")
    ) {
      momentedStartDate.add(1, "day");
      result.push(moment({ ...momentedStartDate }));
    }
    return result;
  };

  const classDatesArray = (arrOfDates) => {
    const days = values.repeatDays;
    let arrDays = [];
    let res = [];
    arrOfDates.forEach((ele, idx) => {
      arrDays.push(
        moment(ele)
          .format("ddd")
          .toLowerCase()
      );
    });
    if (days) {
      arrDays.forEach((item, idx) => {
        if (days.includes(item)) res.push(new Date(arrOfDates[idx]).getTime());
      });
      setFieldValue("classDates", res);
    }
  };

  const addDay = (value) => {
    let array = values.repeatDays || [];
    let found = array.some((el) => el === value);
    if (found) {
      return;
    }
    array.push(value);
    setFieldValue("repeatDays", array);
    setDatesTouched(!datesTouched);
  };
  const addTimesRangeFrom = (value, ind) => {
    let array = timeRanges || [];
    array[ind] = {
      from: value,
      to: array[ind] && array[ind].to !== undefined ? array[ind].to : "",
    };
    seTimeRanges(array);
    setFieldValue("timesArray", array);
  };
  const addTimesRangeTo = (value, ind) => {
    let array = timeRanges || [];
    array[ind] = {
      from: array[ind] && array[ind].from !== undefined ? array[ind].from : "",
      to: value,
    };
    seTimeRanges(array);
    setFieldValue("timesArray", array);
  };
  const addTime = (value) => {
    let timeArr = timesCounter || [];
    timeArr.push(timeArr.length);
    setTimesCounter(timeArr);
    let array = values.timesArray || [];
    setFieldValue("timesArray", array);
  };
  const checkIfCanAddDay = (day) => {
    const { startDate, endDate } = values;
    const momentedStartDate = moment(startDate);
    const momentedendDate = moment(endDate);
    let result = [moment({ ...momentedStartDate })];

    while (
      momentedStartDate.format("YYYY-MM-DD") !=
      momentedendDate.format("YYYY-MM-DD")
    ) {
      momentedStartDate.add(1, "day");
      result.push(moment({ ...momentedStartDate }));
    }
    let canAdd;
    if (result.length < 7) {
      const days = result.map((date, idx) => date.format("dddd"));
      canAdd = days.includes(day);
    } else return false;
    return !canAdd;
  };
  const removeDay = (value) => {
    let array = values.repeatDays || [];

    let selectedArray = array.filter(function(item) {
      return item !== value;
    });
    setFieldValue("repeatDays", selectedArray);
    setDatesTouched(!datesTouched);
  };
  const removeTime = (ind) => {
    let timeArr = timesCounter || [];
    timeArr.splice(ind, 1);
    setTimesCounter(timeArr);
    let timesArrRange = timeRanges || [];
    timesArrRange.splice(ind, 1);
    let selectedArray = values.timesArray || [];
    selectedArray.splice(ind, 1);
    setFieldValue("timesArray", selectedArray);
  };

  React.useEffect(() => {
    if (formikProps.values.type === "ONLINE") {
      setShowAllowUnpaidBookings(false);
    }
  }, [formikProps.values.type]);

  React.useEffect(() => {
    store.dispatch(getPackages(1, 99999, true, undefined, undefined, "class"));
    store.dispatch(getCourts());
  }, []);
  React.useEffect(() => {
    if (values?.gender) {
      store.dispatch(
        getPackages(
          1,
          99999,
          true,
          undefined,
          undefined,
          "class",
          "",
          "",
          "",
          values.gender
        )
      );
    }
  }, [values?.gender]);

  React.useEffect(() => {
    if (typeof toDelete === "number") handleRemoveClass();
  }, [toDelete]);

  React.useEffect(() => {
    let result = getArrayOfDatesInRange();
    classDatesArray(result);
  }, [values.startDate, values.endDate, datesTouched]);

  const handleRemoveClass = () => {
    let relArr = relation;
    relArr.splice(toDelete, 1);
    setRelation(relArr);
    setChanged(!changed);
    setToDelete(null);
  };
  React.useEffect(() => {
    dispatch(getPayRatesType());
  }, [dispatch]);
  const handlePayRateTypesChange = (e) => {
    console.log(e.target.value, "e.target.value");
    if (e.target.value) {
      setSelectedPayRateType(e.target.value);
      dispatch(getPayRates(e.target.value));
    } else {
      setSelectedPayRateType(null);
    }
  };
  const courtsList = React.useMemo(() => FormatObjects(courts, "name"), [
    courts,
  ]);
  const handlePayRateChange = async (e) => {
    if (e.target.value) {
      const selectedId = parseInt(e.target.value, 10);
      setSelectedPayRate(e.target.value);
      if (!payRatesSelected) {
        setIsPayRatesSelected(false);
      }
      const selectedPayRate = payRates.find(
        (payRate) => payRate.id === selectedId
      );
      if (
        selectedPayRate &&
        !payRatesSelected.some((payRate) => payRate.id === selectedId)
      ) {
        setPayRatesSelected(() => {
          const updatedPayRatesSelected = [selectedPayRate];

          // Move the setFieldValue call inside this callback to ensure it uses updated state
          setFieldValue("payRates", updatedPayRatesSelected);
          return updatedPayRatesSelected; // This returns the new state
        });
      }
    } else {
      setFieldValue("payRates", []);
      setSelectedPayRate(null);
    }
  };
  return (
    <div className="mt-4">
      {/* Workshop Type Selection */}
      <FormGroup className="mb-4">
        <Label className="fw-bold workshop-container title mb-3 ">
          What would you like to add?
        </Label>
        <div className="d-flex gap-3">
          <div className="form-check">
            <Input
              type="radio"
              name="workshopType"
              id="workshop"
              value="workshop"
              checked={values.groupType === "workshop"}
              onChange={(e) => {
                setFieldValue("groupType", e.target.value);
              }}
              className="form-check-input"
            />
            <Label
              check
              for="workshop"
              className="workshop-container sub-title mr-4"
            >
              Workshop
            </Label>
          </div>
          <div className="form-check">
            <Input
              type="radio"
              name="groupType"
              id="course"
              value="course"
              checked={values.groupType === "course"}
              onChange={(e) => {
                setFieldValue("groupType", e.target.value);
              }}
              className="form-check-input"
            />
            <Label
              check
              for="course"
              className="form-check-label workshop-container sub-title"
            >
              Course
            </Label>
          </div>
        </div>
      </FormGroup>
      {/* Service Info */}
      <FormGroup className="mb-4 ">
        <Label className="fw-bold workshop-container title">Service Info</Label>
        <Row className="workshop-container service-info">
          <Col md={6} lg={6} className="mt-3">
            <div className="text-center p-4 border-2 border-dashed rounded workshop-container upload-image-container">
              {values.image ? (
                <div className=" profile-image mb-3">
                  <img
                    src={values.image}
                    className="img-fluid img-blk"
                    alt="user"
                  />
                </div>
              ) : (
                <div className="mb-3 workshop-container upload-image-container image-div">
                  <svg
                    class="w-6 h-6 text-gray-800 dark:text-white"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg"
                    width="50"
                    height="50"
                    fill="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M13 10a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H14a1 1 0 0 1-1-1Z"
                      clipRule="evenodd"
                    />
                    <path
                      fill-rule="evenodd"
                      d="M2 6a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v12c0 .556-.227 1.06-.593 1.422A.999.999 0 0 1 20.5 20H4a2.002 2.002 0 0 1-2-2V6Zm6.892 12 3.833-5.356-3.99-4.322a1 1 0 0 0-1.549.097L4 12.879V6h16v9.95l-3.257-3.619a1 1 0 0 0-1.557.088L11.2 18H8.892Z"
                      clipRule="evenodd"
                    />
                  </svg>
                </div>
              )}

              <Button
                style={{
                  backgroundColor: "#7B00A3",
                  borderColor: "#8b5cf6",
                  width: "297px",
                  height: "52px",
                }}
                type="button"
              >
                <DropZone
                  values={values}
                  setFieldValue={setFieldValue}
                  errors={errors}
                  icon={
                    <svg
                      class="w-6 h-6 text-gray-800 dark:text-white"
                      aria-hidden="true"
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      fill="none"
                      viewBox="0 0 24 24"
                    >
                      <path
                        stroke="currentColor"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M4 18V8a1 1 0 0 1 1-1h1.5l1.707-1.707A1 1 0 0 1 8.914 5h6.172a1 1 0 0 1 .707.293L17.5 7H19a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1Z"
                      />
                      <path
                        stroke="currentColor"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
                      />
                    </svg>
                  }
                />
              </Button>
            </div>
            <FormGroup
              className="mt-4 custom-inputs"
              style={{ height: "58px" }}
            >
              <Label className="fw-bold" workshop-container title>
                Workshop/Course Name
              </Label>
              <Field
                type="text"
                name="name"
                id="Class name"
                maxLength={50}
                placeholder="Enter workshop/course name"
                style={{
                  height: "58px",
                  fontSize: "1rem",
                  fontWeight: "400",
                }}
                className={`form-control ${errors.name &&
                  touched.name &&
                  "is-invalid"}`}
              />
              {errors.name ? (
                <div
                  className="invalid-feedback"
                  style={{ display: "block" }}
                >{`${errors.name}`}</div>
              ) : null}
            </FormGroup>
          </Col>

          <Col md={6} lg={6}>
            <FormGroup>
              <Label className="fw-bold" workshop-container title>
                Description
              </Label>
              <Input
                type="textarea"
                rows="3"
                placeholder="Enter the description"
                style={{ resize: "none" }}
                onChange={(e) => {
                  setFieldValue("description", e.target.value);
                }}
                value={values.description}
              />
            </FormGroup>
            <FormGroup>
              <Label className="fw-bold" workshop-container title>
                Pre-requisites
              </Label>
              <Input
                type="textarea"
                rows="3"
                placeholder="Enter the pre-requisites"
                style={{ resize: "none" }}
                onChange={(e) => {
                  setFieldValue("preRequisites", e.target.value);
                }}
                value={values.preRequisites}
              />
            </FormGroup>
            <FormGroup>
              <Label className="fw-bold">Additional Notes</Label>
              <Input
                type="textarea"
                rows="3"
                placeholder="Enter the additional notes"
                style={{ resize: "none" }}
                onChange={(e) => {
                  setFieldValue("notes", e.target.value);
                }}
                value={values.notes}
              />
            </FormGroup>
          </Col>
        </Row>
      </FormGroup>
      {/* When Section */}
      <FormGroup className="mb-4">
        <Label className="fw-bold workshop-container title">When</Label>

        <div className="basic-info">
          <div
            className="card-panel bg-transparent subscription-date-panel"
            style={{ padding: "26px" }}
          >
            <div className="basic-info">
              {!values.edit && (
                <div className="info-title">
                  <Title
                    title={
                      gym.type == "sportClub"
                        ? "Select Group session day"
                        : "Select class day"
                    }
                  />
                </div>
              )}
              {!values.edit && (
                <div className="status-inner-block days-inner-block">
                  <div className="">
                    {weekDays.map((day, idx) => {
                      return (
                        <div className="subscription-plan-list-element">
                          <div className="selction-box mt-0 px-0 mr-3">
                            <div className="checkboxes-list form-check">
                              <label
                                className={`container-blk form-check-label ${
                                  !checkIfCanAddDay(day.label)
                                    ? "black-radio-fonts"
                                    : ""
                                }`}
                                for={`${
                                  values.edit
                                    ? `editinlineRadio5${idx + 5}`
                                    : `inlineRadio5${idx + 5}`
                                }`}
                              >
                                <Input
                                  className="form-check-input max-width-fit-content"
                                  type="checkbox"
                                  name="day"
                                  id={`${
                                    values.edit
                                      ? `editinlineRadio5${idx + 5}`
                                      : `inlineRadio5${idx + 5}`
                                  }`}
                                  disabled={checkIfCanAddDay(day.label)}
                                  value={day.value}
                                  checked={
                                    values.day && values.day.includes(day.value)
                                  }
                                  onChange={(e) => {
                                    if (e.target.checked) {
                                      addDay(e.target.value);
                                    } else {
                                      removeDay(e.target.value);
                                    }
                                  }}
                                />
                                <span class="checkmark"></span>
                                {day.label}
                              </label>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>

                  {errors.repeatDays && touched.repeatDays ? (
                    <div
                      className="invalid-feedback"
                      style={{ display: "block", marginTop: "-20px" }}
                    >{`${errors.repeatDays}`}</div>
                  ) : null}
                </div>
              )}
              <div className="members-date-edit-wrapper blk-padding-y">
                {!values.edit ? (
                  <Row className="date-picker-wrapper add-class-date-wrapper">
                    <Col md={1} className="date-title-block">
                      <h6 className="date-title ctf-tx-secondary mb-0">
                        Date Range
                      </h6>
                    </Col>
                    <Col md={5} className="start-date date-error">
                      <DatePicker
                        dateFormat="dd/MM/yyyy"
                        className="bg-white"
                        name="startDate"
                        placeholderText="From"
                        selected={pickerDate(values.startDate)}
                        onChange={(date) => {
                          setFieldValue("startDate", date);
                          if (moment(date).isAfter(moment(values.endDate)))
                            setFieldValue(
                              "endDate",
                              new Date(
                                moment(date)
                                  .add("days", 1)
                                  .valueOf()
                              )
                            );
                        }}
                      />
                      <div className="d-flex date-picker-img">
                        <img
                          src={require("../../assets/images/date_range.svg")}
                          className="date-picker-logo-img"
                        />
                      </div>
                      {errors.startDate ? (
                        <div
                          className="invalid-feedback"
                          style={{ display: "block" }}
                        >{`${errors.startDate}`}</div>
                      ) : null}
                    </Col>

                    <Col md={5} className="end-date">
                      <DatePicker
                        dateFormat="dd/MM/yyyy"
                        selected={pickerDate(values.endDate)}
                        minDate={pickerDate(values.startDate) || undefined}
                        className="bg-white"
                        name="endDate"
                        placeholderText="To"
                        onChange={(date) => {
                          setFieldValue("endDate", date);
                        }}
                      />
                      <div className="d-flex date-picker-img">
                        <img
                          src={require("../../assets/images/date_range.svg")}
                          className="date-picker-logo-img"
                        />
                      </div>
                      {errors.endDate ? (
                        <div
                          className="invalid-feedback"
                          style={{ display: "block" }}
                        >{`${errors.endDate}`}</div>
                      ) : null}
                    </Col>
                  </Row>
                ) : (
                  <div className="date-picker-wrapper">
                    <div className="date-title-block">
                      <h6 className="date-title ctf-tx-secondary mb-0">Date</h6>
                    </div>
                    <div className="start-date date-error">
                      <DatePicker
                        className="bg-white"
                        dateFormat="dd/MM/yyyy"
                        name="date"
                        placeholderText="date"
                        selected={pickerDate(values.date)}
                        onChange={(date) => {
                          if (date) {
                            let local = moment(date).format("MM/DD/YYYY");
                            let modifiedToUTC = new Date(
                              `${local} UTC`
                            ).getTime();
                            setFieldValue("date", modifiedToUTC);
                          }
                        }}
                      />
                      <div className="d-flex date-picker-img">
                        <img
                          src={require("../../assets/images/date_range.svg")}
                          className="img-fluid"
                        />
                      </div>
                      {errors.date ? (
                        <div
                          className="invalid-feedback"
                          style={{ display: "block" }}
                        >{`${errors.date}`}</div>
                      ) : null}
                    </div>
                  </div>
                )}
              </div>

              <div className="blk-padding-y">
                {timesCounter.map((el, ind) => {
                  return (
                    <Row className="mt-4">
                      <Col md={4}>
                        <FormGroup className="custom-inputs select-box mb-md-0 ">
                          <Input
                            type="time"
                            onChange={(e) => {
                              console.log({ time: e.target.value });
                              addTimesRangeFrom(e.target.value, ind);
                            }}
                            id={"from"}
                            name="from"
                            className={`form-control input time-input 
                         
                               `}
                          />

                          {errors.timesArray && touched.from ? (
                            <div className="invalid-feedback d-block">
                              {`${
                                errors.timesArray[ind]?.from
                                  ? errors?.timesArray[ind]?.from
                                  : typeof errors?.timesArray == "string"
                                  ? errors?.timesArray
                                  : ""
                              }`}
                            </div>
                          ) : null}
                          <Label for="from" className="">
                            {gym.type == "sportClub"
                              ? "Group Session Time"
                              : "Class Start Time"}
                          </Label>
                        </FormGroup>
                      </Col>
                      <Col md={4}>
                        <FormGroup className="custom-inputs select-box mb-md-0 ">
                          <Input
                            type="time"
                            onChange={(e) => {
                              addTimesRangeTo(e.target.value, ind);
                            }}
                            id={"to"}
                            name="to"
                            className={`form-control input time-input `}
                          />
                          {errors.timesArray && touched.to ? (
                            <div className="invalid-feedback d-block">
                              {`${
                                errors.timesArray[ind]?.to
                                  ? errors?.timesArray[ind]?.to
                                  : typeof errors?.timesArray == "string"
                                  ? errors?.timesArray
                                  : ""
                              }`}
                            </div>
                          ) : null}
                          <Label for="to" className="">
                            {gym.type == "sportClub"
                              ? "Group Session End Time"
                              : "Class End Time"}
                          </Label>
                        </FormGroup>
                      </Col>
                      <Col>
                        {timesCounter[ind] == 0 ? (
                          <button
                            className="class-add-btn-times"
                            onClick={() => addTime()}
                            type="button"
                          >
                            +{" "}
                            <span className="add-other-time">
                              {" "}
                              Add other time
                            </span>
                          </button>
                        ) : (
                          <button
                            className="class-delte-btn-times"
                            onClick={() => removeTime(ind)}
                          >
                            -
                          </button>
                        )}
                      </Col>
                    </Row>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </FormGroup>
      {/* Instructor Section */}
      <FormGroup className="mb-4">
        <Label className="fw-bold workshop-container title mb-3">
          Instructor
        </Label>
        <Row>
          <Col md={6}>
            {/* <div className="position-relative"> */}
            <select
              disabled={
                (loginUser.role === "STAFF" && !permissions["S-M-F/U"]) ||
                (subAdminType === "SUB_ADMIN" &&
                  !subAdminPermissions["S-M-F/U"])
              }
              className="form-control form-select"
              value={values.trainer || ""}
              onChange={(e) => {
                setFieldValue("trainer", e.target.value);
              }}
            >
              <option value="">Select Instructor/Coach</option>
              {trainerList.map((trainer) => (
                <option key={trainer.id} value={trainer.id}>
                  {trainer.user_name}
                </option>
              ))}
            </select>
            {/* </div> */}
            {errors.trainer && (
              <div className="invalid-feedback" style={{ display: "block" }}>
                {errors.trainer}
              </div>
            )}
          </Col>
        </Row>
      </FormGroup>
      {/* Capacity & Waitlist */}
      <FormGroup className="mb-4">
        <Label className="fw-bold workshop-container title mb-3 ">
          Capacity & Waitlist
        </Label>
        <Row>
          <Col md={6}>
            <Label> capacity</Label>
            <Field
              type="number"
              name="capacity"
              min={1}
              className={`form-control ${errors.name &&
                touched.name &&
                "is-invalid"}`}
              placeholder="Enter capacity"
            />
            {errors.capacity ? (
              <div
                className="invalid-feedback"
                style={{ display: "block" }}
              >{`${errors.capacity}`}</div>
            ) : null}
          </Col>
          {/* <Col md={6}>
            <Label>Waitlist</Label>
            <Field
              type="number"
              name="waitingListCapacity"
              min={0}
              placeholder="Enter waitlist capacity"
              className={`form-control ${errors.name &&
                touched.name &&
                "is-invalid"}`}
              onChange={(e) => {
                if (e.target.value && e.target.value > 0) {
                  setFieldValue("waitingListRule", "auto");
                  setFieldValue("waitingList", true);
                  setFieldValue("waitingListCapacity", e.target.value);
                } else {
                  setFieldValue("waitingListRule", "");
                  setFieldValue("waitingList", false);
                  setFieldValue("waitingListCapacity", 0);
                }
              }}
            />
          </Col> */}
        </Row>
      </FormGroup>
      {/* Add Pricing */}
      <FormGroup className="mb-4">
        <Label className="fw-bold workshop-container title mb-3 ">
          Add Pricing
        </Label>
        <Row>
          <Col md={6}>
            <Label>Package Name</Label>
            <InputGroup>
              <Field
                type="text"
                name="packageName"
                value={values.packageName}
                className={`form-control ${errors.packageName &&
                  touched.packageName &&
                  "is-invalid"}`}
                placeholder="package name"
              />
              {errors.packageName ? (
                <div
                  className="invalid-feedback"
                  style={{ display: "block" }}
                >{`${errors.packageName}`}</div>
              ) : null}
            </InputGroup>
          </Col>
          <Col md={6}>
            <Label>Price</Label>
            <InputGroup>
              <Field
                type="number"
                name="packagePrice"
                value={values?.packagePrice}
                className={`form-control ${errors.packagePrice &&
                  touched.packagePrice &&
                  "is-invalid"}`}
                placeholder="package price"
                min={0}
              />
              {errors.packagePrice ? (
                <div
                  className="invalid-feedback"
                  style={{ display: "block" }}
                >{`${errors.packagePrice}`}</div>
              ) : null}
            </InputGroup>
          </Col>
        </Row>
        {console.log({ values })}
        <Row className="mt-3">
          <Col md={6}>
            <Label>Number of sessions</Label>
            <Field
              type="number"
              min={1}
              name="numberOfSessions"
              className={`form-control ${errors.numberOfSessions &&
                touched.numberOfSessions &&
                "is-invalid"}`}
              placeholder="package  number of sessions"
            />
            {errors.numberOfSessions ? (
              <div
                className="invalid-feedback"
                style={{ display: "block" }}
              >{`${errors.numberOfSessions}`}</div>
            ) : null}
          </Col>
          <Col md={6}>
            <Label>Expiration</Label>
            <Field
              type="number"
              min={1}
              name="packageDuration"
              placeholder="Package expiration in Days"
              className={`form-control ${errors.packageDuration &&
                touched.packageDuration &&
                "is-invalid"}`}
            />
            {errors.packageDuration ? (
              <div
                className="invalid-feedback"
                style={{ display: "block" }}
              >{`${errors.packageDuration}`}</div>
            ) : null}
          </Col>
        </Row>
      </FormGroup>

      <FormGroup className="mb-4">
        <Label className="fw-bold workshop-container title mb-3 ">
          Workshop/Course Settings
        </Label>
        <Row className="ml-2 mt-3">
          <Col md={4}>
            <FormGroup className="ml-3 mt-0 mb-n2 ">
              <Label className="ctf-tx-size-fifth">
                <Input
                  type="checkbox"
                  name="in"
                  checked={values?.disableOnlineBooking}
                  onChange={(e) => {
                    if (!e.target.checked) {
                      setFieldValue("disableOnlineBooking", false);
                    } else {
                      setFieldValue("disableOnlineBooking", true);
                    }
                  }}
                  className="payment-checkbox"
                />
                Disable Online Bookings
              </Label>
            </FormGroup>
          </Col>
          <Col md={4}>
            <FormGroup className="ml-3 mt-0 mb-n2 ">
              <Label className="ctf-tx-size-fifth">
                <Field
                  type="checkbox"
                  name="in"
                  checked={values?.allowUnpaidBooking}
                  onChange={(e) => {
                    if (!e.target.checked) {
                      setFieldValue("allowUnpaidBooking", false);
                    } else {
                      setFieldValue("allowUnpaidBooking", true);
                    }
                  }}
                  className="payment-checkbox"
                />
                Allow Unpaid Bookings
              </Label>
            </FormGroup>
          </Col>
        </Row>
      </FormGroup>
    </div>
  );
};
